import React from 'react';
import PropTypes from 'prop-types';
import without from 'lodash/without';
import DropdownMenu from '@radix-ui/react-dropdown-menu';
import Check from 'common/icons/Check';
import ChevronRight from 'common/icons/ChevronRight';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { useSessions } from 'common/components/TouchpointEditor/contexts/SessionsContext';
import {
    CheckboxFrame,
    CheckboxIndicator,
    CheckboxSubItem,
    FilterIndicator,
    Filterlabel,
    StyledDropDownMenuSubTrigger,
    StyledDropdownSubContent,
} from './SessionFilter.styles';

export default function SessionLocationsSubFilter({
    backgroundColor,
    backgroundColorHover,
    fontColor,
    fontSize,
    fontFamily,
    iconColor,
    borderColor,
    displayLabel,
}) {
    const {
        theme: { activeFonts, colors },
    } = useTouchpointData();
    const sessions = useSessions();

    const onFilteredLocationSelect = (location) => {
        const updatedSessionLocationFilterIds = sessions.filters.locations?.includes(location)
            ? without(sessions.filters.locations, location)
            : sessions.filters.locations.concat(location);

        sessions.filters.setLocations(updatedSessionLocationFilterIds);
    };
    const sessionFiltersArray = sessions.uniqueLocations ? sessions.uniqueLocations.sort() : [];
    const locations = sessionFiltersArray.map((loc) => {
        const checked = sessions.filters.locations?.includes(loc);
        return (
            <CheckboxSubItem
                key={loc}
                checked={checked}
                $backgroundColorHover={colors[backgroundColorHover]}
                $borderColor={borderColor}
                onCheckedChange={() => onFilteredLocationSelect(loc)}
                onSelect={(e) => e.preventDefault()}
            >
                <CheckboxFrame $iconColor={iconColor}>
                    <CheckboxIndicator>
                        <Check />
                    </CheckboxIndicator>
                </CheckboxFrame>
                {loc}
            </CheckboxSubItem>
        );
    });

    return (
        <DropdownMenu.Sub>
            <StyledDropDownMenuSubTrigger
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
                $iconColor={iconColor}
                $borderColor={borderColor}
            >
                <Filterlabel>
                    {displayLabel}
                    {sessions.filters.locations?.length > 0 ? (
                        <FilterIndicator $backgroundColor={colors[fontColor]} $fontColor={colors[backgroundColor]}>
                            {sessions.filters.locations?.length}
                        </FilterIndicator>
                    ) : null}
                </Filterlabel>
                <ChevronRight />
            </StyledDropDownMenuSubTrigger>
            <StyledDropdownSubContent
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
            >
                {locations}
            </StyledDropdownSubContent>
        </DropdownMenu.Sub>
    );
}

SessionLocationsSubFilter.propTypes = {
    backgroundColor: PropTypes.number.isRequired,
    backgroundColorHover: PropTypes.number.isRequired,
    fontColor: PropTypes.number.isRequired,
    fontSize: PropTypes.number.isRequired,
    fontFamily: PropTypes.number.isRequired,
    displayLabel: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired,
    borderColor: PropTypes.string.isRequired,
};
